// extracted by css-extract-rspack-plugin
export default {"wrapper":"MultiCreationAuctionPage-module__wrapper--R7WiY"};